<div class="mt-2">
    <div class="row justify-content-center">
        <div class="col-md-6">
            <div class="card p-3">
                <form [formGroup]="ctaForm" (ngSubmit)="onSubmit(ctaForm)">
                    <div class="row">

                        <!-- Blog Selector -->
                        <div class="col-md-12">
                            <label class="form-label">Select Blog</label>
                            <ng-select
                                formControlName="blog_id"
                                (change)="onBlogChange($event)">
                                <ng-option *ngFor="let blog of allMedia"
                                    [value]="blog.id">
                                    {{ blog.heading }}
                                </ng-option>
                            </ng-select>
                        </div>

                        <div *ngIf="loadingCtaValues" class="text-center my-3">
                            <div class="spinner-border text-primary"
                                role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>

                        <!-- CTA Values -->
                        <div class="col-md-12 mt-4"
                            *ngIf="cta_values.length && !loadingCtaValues">
                            <div formArrayName="cta_values">
                                <div
                                    *ngFor="let cta of cta_values.controls; let i = index"
                                    [formGroupName]="i"
                                    class="border p-3 mb-3 position-relative rounded bg-light shadow-sm">

                                    <button
                                        type="button"
                                        class="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 mb-4"
                                        (click)="deleteCta(i)">
                                        <i class="fa fa-times"></i>
                                    </button>

                                    <div class="row mt-3">
                                        <div class="col-md-6">
                                            <label>Link</label>
                                            <input class="form-control"
                                                formControlName="link"
                                                placeholder="Link">
                                        </div>
                                        <div class="col-md-6">
                                            <label>CTA Text</label>
                                            <input class="form-control"
                                                formControlName="heading"
                                                placeholder="Heading">
                                        </div>
                                    </div>

                                    <div
                                        class="form-group d-flex my-2">
                                        <input type="text"
                                            class="form-control"
                                            placeholder="Icon URL"
                                            formControlName="icon" />

                                        <a [href]="cta.get('icon')?.value"
                                            target="_blank"
                                            *ngIf="cta.get('icon')?.value">
                                            <img class="ms-1"
                                                height="40"
                                                [src]="cta.get('icon')?.value">
                                        </a>
                                        <button
                                            class="btn btn-primary ms-1"
                                            type="button"
                                            (click)="openUploadModal('cta_values_icon', i)">
                                            <i
                                                class="fas fa-cloud-upload-alt"></i>
                                        </button>
                                    </div>
                                    <!-- CTA Text Editor -->
                                    <div class="row">
                                        <div class="col-md-12">
                                            <!-- <label>CTA Text</label> -->
                                            <ckeditor
                                                [editor]="Editor"
                                                formControlName="cta_text"
                                                [config]="{ placeholder: 'Enter CTA text...' }">
                                            </ckeditor>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <!-- Add CTA Button -->
                            <button
                                type="button"
                                class="btn btn-sm btn-success float-end"
                                (click)="addNewCta()"
                                *ngIf="cta_values.length < 10">
                                <i class="fa fa-plus"></i> Add CTA
                            </button>
                        </div>

                        <!-- Submit -->
                        <div class="col-md-12 mt-4">
                            <button class="btn btn-info w-100" type="submit">
                                <i
                                    [ngClass]="{'fa fa-pulse fa-spin fa-spinner': isUpdating, 'bx bx-save': !isUpdating}"></i>
                                Save All
                            </button>
                        </div>

                    </div>
                </form>
            </div>
        </div>
    </div>
</div>